import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1024,
	height: 1024,
	viewBox: "0 0 1024 1024",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3_20809)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H1024V1024H0V0Z",
				fill: "#ED2939"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256 0H512V1024H256V0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 384H1024V640H0V384Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M320 0H448V1024H320V0Z",
				fill: "#002664"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 448H1024V576H0V448Z",
				fill: "#002664"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3_20809",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 1024,
			height: 1024,
			rx: 512,
			fill: "white"
		})
	}) })]
});
export default SvgNo;
